import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  colorBgInfoBold,
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgInfoHovered,
} from 'src/app/themes/primaryThemeDefault'
import { DECISION_TYPE } from '../constants'
import { useSelector } from 'react-redux'
import { getLookupValues } from 'src/app/store/masterSetup'

export interface IStatusTag {
  status: string
}

const DefaultDecisionTag: React.FC<IStatusTag> = (props) => {
  const { status } = props
  const { t } = useTranslation()
  const lookupValues = useSelector(getLookupValues)

  const getLabel = (status: string) => {
    const lookup = lookupValues?.DefaultDecision?.find((item) => item.value === status)
    return lookup ? lookup.label : ''
  }


// FThis solution only works for now, further processing is needed to cover other cases
  const getConfig = useCallback(
    (status: string) => {
      switch (status) {
        case DECISION_TYPE.RETURN:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: getLabel(DECISION_TYPE.RETURN),
          }
        default:
          return {
            backgroundColor: colorBgInfoHovered,
            color: colorBgInfoBold,
            text: getLabel(DECISION_TYPE.PAY),
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default DefaultDecisionTag
